/**
 * TanStack Router concatenates `links` from every matched route without
 * deduping, so a parent route's canonical is emitted alongside the leaf's.
 * Google then sees two conflicting canonicals and can drop the child page.
 *
 * Parent routes that are also real pages (e.g. /states/$state, which is the
 * parent of /states/$state/$town) must emit their canonical only when they are
 * the leaf match.
 */
export function leafCanonical(
  href: string,
  ctx: { match: { id: string }; matches: ReadonlyArray<{ id: string }> },
): Array<{ rel: string; href: string }> {
  const leafId = ctx.matches[ctx.matches.length - 1]?.id;
  return leafId === ctx.match.id ? [{ rel: "canonical", href }] : [];
}
